import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import CopyLinkButton from "../CopyLinkButton";
import "./index.css";

const FAQAccordion = ({ question, answer, id }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      id={id}
      className={`faq-accordion copy-link-target ${isOpen ? "open" : ""}`}
      style={{ position: "relative" }}
    >
      <CopyLinkButton anchorId={id} className="faq-item-copy-link" />
      <div className="faq-question" onClick={() => setIsOpen(!isOpen)}>
        <h3 className="faq-question-text">{question}</h3>
        <div>
        <svg
          className="faq-plus-icon"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="24"
            cy="24"
            r="22"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
          />
          <line
            x1="24"
            y1="16"
            x2="24"
            y2="32"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
          />
          <line
            x1="16"
            y1="24"
            x2="32"
            y2="24"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>

        <svg
          className="faq-minus-icon"
          width="48"
          height="48"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="24"
            cy="24"
            r="22"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
          />
          <line
            x1="16"
            y1="24"
            x2="32"
            y2="24"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
        </div>
      </div>
      <div className="faq-answer descriptionTextP">
        {ReactHtmlParser(answer)}
      </div>
    </div>
  );
};

export default FAQAccordion;
